import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpune() {



const cardData = {
  keyword: "Corporate Cab Service in Pune",
  heading: "Lotus Cab: Corporate Cab Service in Pune",

  headingDescription:
    "Lotus Cab offers professional and reliable Corporate Cab Service in Pune designed specifically for companies, IT parks, startups, and large enterprises. Whether you require employee transportation, executive airport transfers, business meeting taxis, or long-term monthly cab contracts, our fleet of AC sedan and SUV vehicles ensures comfort and punctuality. Our background-verified chauffeurs maintain professionalism and safety standards for corporate travel. We provide transparent per-km billing, customized company contracts, and 24/7 support. With timely pickups and structured travel coordination, Lotus Cab delivers seamless corporate mobility solutions across Pune.",

  top: "Top Corporate & Business Hubs in Pune Served by Lotus Cab",

  topPlaces: [
    {
      title: "Hinjewadi IT Park",
      description:
        "Hinjewadi IT Park is Pune’s largest technology hub. It houses major multinational companies and IT firms. Thousands of employees commute daily. Corporate cab service is essential for punctual office travel. Located in multiple phases. A key corporate destination in Pune."
    },
    {
      title: "EON IT Park Kharadi",
      description:
        "EON IT Park in Kharadi hosts global technology companies. It is one of Pune’s fastest-growing business zones. Daily employee transportation demand is high. Corporate airport transfers are common here. Located near World Trade Center. A major IT business center."
    },
    {
      title: "Magarpatta City",
      description:
        "Magarpatta City is a large integrated business township. It includes corporate offices and IT companies. Popular for employee and executive travel. Well-connected to city roads. Ideal location for corporate cab operations. Frequently served by office staff cabs."
    },
    {
      title: "Baner Business District",
      description:
        "Baner has rapidly developed into a corporate hub. Many startups and tech firms operate here. Business meetings and airport transfers are frequent. Requires reliable cab service for staff mobility. Located in western Pune. Important corporate zone."
    },
    {
      title: "Koregaon Park Business Area",
      description:
        "Koregaon Park hosts corporate offices and luxury business centers. Executive travel and airport pickups are common. Popular for business meetings and conferences. Premium cab services frequently required. Central location in Pune. Suitable for corporate clients."
    },
    {
      title: "Viman Nagar Corporate Offices",
      description:
        "Viman Nagar is near Pune Airport and houses major companies. Corporate airport transfers are frequent here. Employee transportation services are essential. Well-connected road network available. Popular for business travel. A key service area."
    },
    {
      title: "Talawade IT Park",
      description:
        "Talawade MIDC IT Park hosts software and manufacturing companies. Corporate travel demand is steady. Monthly cab contracts are common. Reliable staff transportation required. Located in PCMC region. A growing corporate zone."
    },
    {
      title: "Wakad Business Hub",
      description:
        "Wakad is an emerging business area in Pune. Houses multiple offices and commercial complexes. Corporate employee commute demand is high. Easy highway connectivity available. Growing need for executive cab service. Frequently served area."
    }
  ],

  services: [
    {
      name: "Corporate Taxi Pune",
      description:
        "Professional corporate taxi service for daily office commute and business travel. Clean AC sedan and SUV vehicles available. Transparent per-km billing ensured. Experienced drivers maintain punctuality. Suitable for executives and employees. Reliable corporate mobility solution."
    },
    {
      name: "Employee Transportation Pune",
      description:
        "Structured employee transportation services with monthly contracts. Timely office pickup and drop ensured. Background-verified drivers provided. Comfortable vehicles available. Safe and dependable travel guaranteed. Ideal for IT and corporate firms."
    },
    {
      name: "Corporate Airport Transfer Pune",
      description:
        "Efficient airport pickup and drop for corporate clients. Flight tracking support included. Professional chauffeurs ensure punctual arrival. AC vehicles available for executive comfort. Transparent billing maintained. Suitable for domestic and international transfers."
    },
    {
      name: "Monthly Cab Contract Pune",
      description:
        "Customized monthly cab contracts for companies. Flexible per-km or fixed pricing options available. Dedicated vehicle allocation possible. Reliable daily service ensured. Transparent invoicing provided. Ideal for long-term corporate partnerships."
    },
    {
      name: "Luxury Corporate Taxi Pune",
      description:
        "Premium luxury vehicles available for senior executives and VIP guests. Superior comfort and professional service ensured. Ideal for conferences and corporate events. Well-maintained high-end fleet provided. Executive travel experience guaranteed."
    },
    {
      name: "Sedan Corporate Cab Pune",
      description:
        "Comfortable sedan options for executive travel and meetings. Ideal for business trips within city and airport transfers. AC vehicles maintained regularly. Transparent pricing ensured. Safe and punctual rides guaranteed."
    },
    {
      name: "SUV Corporate Cab Pune",
      description:
        "Spacious SUV vehicles suitable for group executive travel. Extra luggage space available. Comfortable seating ensured. Professional chauffeurs provided. Ideal for team transfers and events. Reliable corporate transport service."
    },
    {
      name: "24/7 Corporate Cab Pune",
      description:
        "Round-the-clock corporate taxi service for urgent meetings and night shifts. Safe and secure rides ensured. Experienced drivers available anytime. Transparent fare policy maintained. Reliable business travel support."
    }
  ],

  tableData: [
    ["Corporate Cab Service in Pune", "Corporate Taxi Pune"],
    ["Employee Transportation Pune", "IT Company Cab Service Pune"],
    ["Office Staff Cab Pune", "Corporate Airport Transfer Pune"],
    ["Monthly Cab Contract Pune", "Luxury Corporate Taxi Pune"],
    ["Sedan Corporate Cab Pune", "SUV Corporate Cab Pune"],
    ["Business Meeting Taxi Pune", "Corporate Event Transportation Pune"],
    ["24/7 Corporate Cab Pune", "Professional Driver Cab Pune"],
    ["Company Lease Cab Service Pune", "Executive Cab Service Pune"],
    ["Corporate Travel Solutions Pune", "Airport Pickup for Companies Pune"],
    ["Reliable Corporate Cab Pune", "Corporate Cab Per Km Rate Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Professional Corporate Drivers",
      WhyChoosedescription:
        "Background-verified and trained chauffeurs ensure safe and professional service."
    },
    {
      WhyChooseheading: "Transparent Billing Structure",
      WhyChoosedescription:
        "Clear per-km rates and monthly invoicing options available."
    },
    {
      WhyChooseheading: "Customized Corporate Contracts",
      WhyChoosedescription:
        "Flexible monthly and long-term agreements for companies."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock service for night shifts and urgent travel."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription:
        "Clean and serviced sedan and SUV vehicles for executive comfort."
    },
    {
      WhyChooseheading: "Airport & Event Transfers",
      WhyChoosedescription:
        "Specialized service for corporate airport pickup and events."
    },
    {
      WhyChooseheading: "Reliable Employee Transport",
      WhyChoosedescription:
        "Structured employee commute solutions with punctual service."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Experienced in handling large corporate accounts efficiently."
    }
  ]
};

const faqData = [
  { question: "Do you provide monthly corporate cab contracts?", answer: "Yes, customized monthly contracts are available for companies." },
  { question: "Is 24/7 corporate cab service available?", answer: "Yes, round-the-clock service including night shifts is provided." },
  { question: "Do you offer airport transfers for executives?", answer: "Yes, corporate airport pickup and drop services are available." },
  { question: "Are drivers verified?", answer: "Yes, all corporate drivers are background-verified and trained." },
  { question: "Do you provide SUV options?", answer: "Yes, SUV vehicles are available for group and executive travel." },
  { question: "Is billing transparent?", answer: "Yes, clear per-km and monthly billing structure is maintained." },
  { question: "Can companies lease vehicles?", answer: "Yes, company lease cab service is available." },
  { question: "Do you provide event transportation?", answer: "Yes, corporate event transportation is supported." },
  { question: "Are vehicles AC?", answer: "Yes, all corporate vehicles are air-conditioned." },
  { question: "Can I book executive luxury taxi?", answer: "Yes, luxury corporate taxi options are available." }
];

const testimonials = [
  {
    id: 1,
    name: "HR Manager – IT Company",
    feedback:
      "We signed a monthly contract for employee transportation. Lotus Cab has maintained punctuality and professionalism consistently. Highly reliable service.",
    rating: 5
  },
  {
    id: 2,
    name: "Operations Head – Corporate Firm",
    feedback:
      "Corporate airport transfers for our executives are handled smoothly. Clean vehicles and professional drivers. Transparent billing impressed us.",
    rating: 5
  },
  {
    id: 3,
    name: "Admin Manager – Startup",
    feedback:
      "Very dependable corporate cab service in Pune. Flexible contracts and 24/7 support make operations easy for our team.",
    rating: 5
  }
];


































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Pune",
  "image": "https://lotuscab.com/assets/images/corporate-cab-service-pune.jpg", 
  "description": "Lotus Cab offers professional corporate cab services in Pune, including employee transportation, IT company cab services, office staff pickups, corporate airport transfers, monthly contracts, and luxury sedan & SUV cabs. Reliable and safe travel solutions for business meetings, corporate events, and executive transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "599",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/corporate-cab-service-pune"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Corporate Cab Service in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book corporate cab services in Pune with Lotus Cab. Employee transportation, IT company cabs, office staff pickups, corporate airport transfers, and luxury sedan & SUV cabs. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Corporate Cab Service in Pune, Corporate Taxi Pune, Employee Transportation Pune, IT Company Cab Service Pune, Office Staff Cab Pune, Corporate Airport Transfer Pune, Monthly Cab Contract Pune, Luxury Corporate Taxi Pune, Sedan Corporate Cab Pune, SUV Corporate Cab Pune, Business Meeting Taxi Pune, Corporate Event Transportation Pune, 24/7 Corporate Cab Pune, Professional Driver Cab Pune, Company Lease Cab Service Pune, Executive Cab Service Pune, Corporate Travel Solutions Pune, Airport Pickup for Companies Pune, Reliable Corporate Cab Pune, Corporate Cab Per Km Rate Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpune;